"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCovid19BoosterDto = instanceOfCovid19BoosterDto;
exports.Covid19BoosterDtoFromJSON = Covid19BoosterDtoFromJSON;
exports.Covid19BoosterDtoFromJSONTyped = Covid19BoosterDtoFromJSONTyped;
exports.Covid19BoosterDtoToJSON = Covid19BoosterDtoToJSON;
exports.Covid19BoosterDtoToJSONTyped = Covid19BoosterDtoToJSONTyped;
/**
 * Check if a given object implements the Covid19BoosterDto interface.
 */
function instanceOfCovid19BoosterDto(value) {
    if (!('boosterNumber' in value) || value['boosterNumber'] === undefined)
        return false;
    if (!('manufacturer' in value) || value['manufacturer'] === undefined)
        return false;
    if (!('dateAdministered' in value) || value['dateAdministered'] === undefined)
        return false;
    if (!('lotNumber' in value) || value['lotNumber'] === undefined)
        return false;
    if (!('clinicName' in value) || value['clinicName'] === undefined)
        return false;
    return true;
}
function Covid19BoosterDtoFromJSON(json) {
    return Covid19BoosterDtoFromJSONTyped(json, false);
}
function Covid19BoosterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'boosterNumber': json['boosterNumber'],
        'manufacturer': json['manufacturer'],
        'dateAdministered': json['dateAdministered'],
        'lotNumber': json['lotNumber'],
        'clinicName': json['clinicName'],
    };
}
function Covid19BoosterDtoToJSON(json) {
    return Covid19BoosterDtoToJSONTyped(json, false);
}
function Covid19BoosterDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'boosterNumber': value['boosterNumber'],
        'manufacturer': value['manufacturer'],
        'dateAdministered': value['dateAdministered'],
        'lotNumber': value['lotNumber'],
        'clinicName': value['clinicName'],
    };
}
//# sourceMappingURL=Covid19BoosterDto.js.map